import {
  Container,
  Stack,
  Box,
  Flex,
  Heading,
  Text,
  Button,
  Tabs,
  TabPanel,
  TabList,
  Tab,
  TabPanels,
  Badge,
  Tooltip
} from "@chakra-ui/react";
import { Link as ExtLink } from "@chakra-ui/react";
import CombinedHeading from "../../common/CombinedHeading";
import { motion } from "framer-motion";

import { FaPaperPlane, FaHammer, FaPlane, FaFly } from "react-icons/fa";
import { FaCheck } from "react-icons/fa";
import { PiPottedPlantFill } from "react-icons/pi";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { IoRocketSharp } from "react-icons/io5";
import { FiChevronsDown } from "react-icons/fi";
import { ImCross } from "react-icons/im";


import { PopupButton } from "react-calendly";
import { linksConfig } from "../../../utils/CommonLinks";
import { useEffect, useRef, useState } from "react";
import { IoMdArrowDropright } from "react-icons/io";
import { WarningIcon } from "@chakra-ui/icons";
import { ReactSession } from "react-client-session";

const PAGE_NAME = 'home';
const SECTION_NAME = 'pricing';

export const featureList = {
    rpc: [
      "Total Credits",
      "RPC req/sec",
      "Index req/sec",
      "Accelerated gPA",
      "sendTransaction/sec",
      "Jito simulateBundle",
      "Staked Connections",
    ],
    grpc: [
      "IP limit",
      "Connections",
      "Cost for Additional Connections",
    ],
    api: [
      "API req/sec"
    ],
  };

  export const FREE_DETAILS = {
    rpc: {
      totalCredits: "Unlimited",
      rate: 10,
      indexCallsRate: 0,
      acceleratedGpa: false,
      sendTxRate: 1,
      simulateBundle: true,
      swqos: false,
    },
    grpc: {
      noIp: false,
      connPerIp: false,
      addIpCost: false,
    },
    api: {
      rate: 1
    },
  };

  export const BUILD_DETAILS = {
    rpc: {
      totalCredits: "Unlimited",
      rate: 100,
      indexCallsRate: 10,
      acceleratedGpa: true,
      sendTxRate: 20,
      simulateBundle: true,
      swqos: true,
    },
    grpc: {
      noIp: "Unlimited",
      connPerIp: 10,
      addIpCost: "$100 / 10 conns",
    },
    api: {
      rate: 10
    },
  };

  export const GROW_DETAILS = {
    rpc: {
      totalCredits: "Unlimited",
      rate: 150,
      indexCallsRate: 20,
      acceleratedGpa: true,
      sendTxRate: 40,
      simulateBundle: true,
      swqos: true,
    },
    grpc: {
      noIp: "Unlimited",
      connPerIp: 20,
      addIpCost: "$100 / 10 conns",
    },
    api: {
      rate: 30
    },
  };

  export const ACCELERATE_DETAILS = {
    rpc: {
      totalCredits: "Unlimited",
      rate: 400,
      indexCallsRate: 40,
      acceleratedGpa: true,
      sendTxRate: 80,
      simulateBundle: true,
      swqos: true,
    },
    grpc: {
      noIp: "Unlimited",
      connPerIp: 50,
      addIpCost: "$100 / 10 conns",
    },
    api: {
      rate: 100,
    },
  };

export default function PricingStatic({pageName}) {
  const MotionStack = motion(Stack);
  const [mobileSelect, setMobileSelect] = useState("FREE");
  const [currentlySelected, setCurrentlySelected] = useState("GROW");

  const definedRef = useRef(null);

  useEffect(() => {
    const hash = window.location.hash;
    console.log(hash)
    
      if (hash === "#free") {
        console.log(1)
        // definedRef.current.scrollIntoView({ behavior: "smooth" });
        setCurrentlySelected("FREE");
      } else if (hash === "#build" && definedRef.current) {
        console.log(2)
        // definedRef.current.scrollIntoView({ behavior: "smooth" });
        setCurrentlySelected("BUILD");
      } else if (hash === "#accelerate" && definedRef.current) {
        console.log(3)
        // definedRef.current.scrollIntoView({ behavior: "smooth" });
        setCurrentlySelected("ACCELERATE");
      } else if (hash === "#grow" && definedRef.current) {
        console.log(4)
        // definedRef.current.scrollIntoView({ behavior: "smooth" });
        setCurrentlySelected("GROW");
      } 
  }, [window.location.hash]);

  const highlightSection = (scrollTo) => {
    const element = document.getElementById(scrollTo);
    console.log(element);
    if (element && scrollTo === "free") {
      setCurrentlySelected("FREE");
      element.scrollIntoView({ behavior: "smooth" });
    } else if (element && scrollTo === "build") {
      setCurrentlySelected("BUILD");
      element.scrollIntoView({ behavior: "smooth" });
    } else if (element && scrollTo === "accelerate") {
      setCurrentlySelected("ACCELERATE");
      element.scrollIntoView({ behavior: "smooth" });
    } else if (element && scrollTo === "grow") {
      setCurrentlySelected("GROW");
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const navigateToPricing = () => {
    ReactSession.set("lastNavigate", "pricing");
    window.location.replace("/pricing");
  }

  

  return (
    <Stack as="div" bg={"#111"} id="shyft-pricing">
      <Container maxW={"7xl"} pt={{ base: 10, md: 20 }} pb={{ base: 4, md: 4 }}>
        <CombinedHeading
          topHeading="No Credits. No Bandwidth Limits. No Overages."
          mainHeading="Pricing That You Always Wanted"
          subHeading="Power your Solana projects with the best infrastructure layer without worrying about credit consumption or overage charges."
          isCenter={true}
        />

        <Tabs variant="unstyled" isFitted mb={10} pt={10}>
          <TabList
            border="1px solid"
            borderColor={"brand.faintGrey"}
            borderRadius="8px"
            mb={8}
            mx="auto"
            width={{ base: "100%", md: "60%" }}
          >
            <Tab
              py={4}
              px={8}
              color={"brand.white"}
              bg={"transparent"}
              fontWeight="600"
              borderRadius="8px 0 0 8px"
              _selected={{
                bg: "brand.red",
                color: "brand.white",
              }}
              _hover={{
                bg: "brand.white",
                color: "brand.red",
              }}
            >
              <Badge
                ml="1"
                mt={"-1px"}
                bg={"brand.yellow"}
                color={"brand.black"}
                me={1}
              >
                New
              </Badge>
              {"  "}Unlimited RPCs + gRPC
            </Tab>
            <Tab
              py={4}
              px={8}
              color={"brand.white"}
              bg={"transparent"}
              fontWeight="600"
              borderRadius="0 8px 8px 0"
              _selected={{
                bg: "brand.red",
                color: "brand.white",
              }}
              _hover={{
                bg: "brand.white",
                color: "brand.red",
              }}
            >
              Old RPC Plans
            </Tab>
          </TabList>

          <TabPanels>
            {/* Shared gRPC Network Panel */}
            <TabPanel p={0}>
              <Box
                bg={"transparent"}
                borderRadius="xl"
                border="1px solid"
                borderColor={"transparent"}
                overflow="hidden"
                boxShadow="lg"
              >
                <Stack
                  as="div"
                  spacing={{ base: 5 }}
                  pt={{ base: 6, md: 3 }}
                  pb={{ base: 6, md: 8 }}
                >
                  <Flex
                    justifyContent={{
                      base: "space-around",
                      xl: "space-between",
                    }}
                    flexWrap={"wrap"}
                  >
                    <MotionStack
                      border={"2px solid"}
                      borderColor="brand.lightGray"
                      py={8}
                      px={6}
                      width="300px"
                      mt={6}
                      className="each_plan"
                      initial={{ opacity: 0, y: 10 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.3, delay: 0.3 }}
                    >
                      <Box maxW={"48px"} transform={"rotate(20deg)"}>
                        <FaPaperPlane size={"24"} color="#E33535" />
                      </Box>
                      <Text
                        as={"div"}
                        textAlign={"start"}
                        fontSize={"4xl"}
                        color={"brand.white"}
                        fontFamily={"heading"}
                        fontWeight={"700"}
                      >
                        Free
                      </Text>

                      <Flex justifyContent={"start"}>
                        <Box>
                          <Text
                            as={"div"}
                            fontSize={"2xl"}
                            fontWeight={"500"}
                            color={"brand.white"}
                            fontFamily={"heading"}
                            px={1}
                          >
                            $0
                            <Text
                              as={"span"}
                              fontSize={"lg"}
                              fontWeight={"400"}
                              color={"brand.lightGray"}
                              opacity={0.5}
                            >
                              /month
                            </Text>
                          </Text>
                        </Box>
                      </Flex>

                      <Stack mt={8}>
                        <Stack spacing={3}>
                          <Stack
                            direction={"row"}
                            pt={1}
                            className="plan_bullet_points"
                          >
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.yellow"
                              fontWeight={"500"}
                            >
                              {" "}
                              Unlimited Credits
                            </Text>
                          </Stack>

                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              20 RPC req/sec
                            </Text>
                          </Stack>

                          <Stack
                            direction={"row"}
                            pt={1}
                            className="plan_bullet_points"
                            mt={-1}
                          >
                            <Box>
                              <Box pt={"2px"}>
                                <ImCross
                                  color="#808080"
                                  size={15}
                                  opacity={0.4}
                                />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color={"brand.midGrey"}
                              fontWeight={"500"}
                              opacity={0.4}
                            >
                              {" "}
                              No gRPC Access
                            </Text>
                          </Stack>

                          <Stack
                            direction={"row"}
                            pt={1}
                            className="plan_bullet_points"
                            mt={-1}
                          >
                            <Box>
                              <Box pt={"2px"}>
                                <ImCross
                                  color="#808080"
                                  size={15}
                                  opacity={0.4}
                                />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color={"brand.midGrey"}
                              fontWeight={"500"}
                              opacity={0.4}
                            >
                              {" "}
                              No RabbitStream Access
                            </Text>
                          </Stack>
                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              1 API req/sec
                            </Text>
                          </Stack>
                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <ImCross
                                  color="#808080"
                                  size={15}
                                  opacity={0.4}
                                />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                              opacity={0.4}
                            >
                              {" "}
                              Staked Connections
                            </Text>
                          </Stack>
                        </Stack>
                      </Stack>

                      <Box textAlign={"start"} pt={"16px"} height={"52px"}>
                        <Stack
                          direction={"row"}
                          onClick={() => highlightSection("free")}
                          cursor={"pointer"}
                        >
                          <Box>
                            <Box pt={"2px"}>
                              <FiChevronsDown
                                color="#E33535"
                                className="know_more_arrow"
                                size={"20px"}
                              />
                            </Box>
                          </Box>
                          <Text
                            as={"div"}
                            fontFamily={"Jost"}
                            fontSize={{ base: "14px", md: "md" }}
                            color="brand.midGrey"
                            fontWeight={"500"}
                            className="each_plan_text_button"
                          >
                            {" "}
                            Know More
                          </Text>
                        </Stack>
                      </Box>

                      <Box w={"100%"} height={"18px"}></Box>

                      <Stack>
                        <ExtLink
                          as={"a"}
                          // href={"/dashboard/pricing"}
                          onClick={navigateToPricing}
                          _hover={{
                            textDecoration: "none",
                          }}
                          data-fast-goal={`${pageName}_${SECTION_NAME}_free_but`}
                        >
                          <Box
                            size={"sm"}
                            width={"full"}
                            height={"12"}
                            margin={"0 auto"}
                            border={"1px solid"}
                            borderColor={"brand.red"}
                            borderRadius={"full"}
                            className="each_plan_button"
                            fontFamily={"heading"}
                            fontWeight={"500"}
                            fontSize={{ base: "sm", md: "md" }}
                            lineHeight={"38px"}
                            paddingTop={"4px"}
                            textAlign={"center"}
                            _hover={{
                              textDecoration: "none",
                            }}
                          >
                            Get Started
                          </Box>
                        </ExtLink>
                      </Stack>
                    </MotionStack>

                    <MotionStack
                      border={"2px solid"}
                      borderColor="brand.lightGray"
                      py={8}
                      px={6}
                      width="300px"
                      mt={6}
                      className="each_plan"
                      initial={{ opacity: 0, y: 10 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.3, delay: 0.3 }}
                    >
                      <Box maxW={"48px"}>
                        <FaFly size={"24"} color="#E33535" />
                      </Box>
                      <Text
                        as={"div"}
                        textAlign={"start"}
                        fontSize={"4xl"}
                        color={"brand.white"}
                        fontFamily={"heading"}
                        fontWeight={"700"}
                      >
                        Build
                      </Text>

                      <Flex justifyContent={"start"}>
                        <Box>
                          <Text
                            as={"div"}
                            fontSize={"2xl"}
                            fontWeight={"500"}
                            color={"brand.white"}
                            fontFamily={"heading"}
                            px={1}
                          >
                            $199
                            <Text
                              as={"span"}
                              fontSize={"lg"}
                              fontWeight={"400"}
                              color={"brand.lightGray"}
                              opacity={0.5}
                            >
                              /month
                            </Text>
                          </Text>
                        </Box>
                      </Flex>

                      <Stack mt={6}>
                        <Stack spacing={3}>
                          <Stack
                            direction={"row"}
                            pt={1}
                            className="plan_bullet_points"
                          >
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.yellow"
                              fontWeight={"500"}
                            >
                              {" "}
                              Unlimited Credits
                            </Text>
                          </Stack>

                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              100 RPC req/sec
                            </Text>
                          </Stack>

                          <Stack
                            direction={"row"}
                            pt={1}
                            className="plan_bullet_points"
                          >
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.yellow"
                              fontWeight={"500"}
                            >
                              {" "}
                              gRPC Access
                            </Text>
                          </Stack>
                          <Stack
                            direction={"row"}
                            pt={1}
                            className="plan_bullet_points"
                          >
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.yellow"
                              fontWeight={"500"}
                            >
                              {" "}
                              RabbitStream Access
                            </Text>
                          </Stack>
                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              10 API req/sec
                            </Text>
                          </Stack>
                          
                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              Staked Connections
                            </Text>
                          </Stack>
                        </Stack>
                      </Stack>

                      <Box textAlign={"start"} pt={"16px"} height={"52px"}>
                        <Stack
                          direction={"row"}
                          onClick={() => highlightSection("build")}
                          cursor={"pointer"}
                        >
                          <Box>
                            <Box pt={"2px"}>
                              <FiChevronsDown
                                color="#E33535"
                                className="know_more_arrow"
                                size={"20px"}
                              />
                            </Box>
                          </Box>
                          <Text
                            as={"div"}
                            fontFamily={"Jost"}
                            fontSize={{ base: "14px", md: "md" }}
                            color="brand.midGrey"
                            fontWeight={"500"}
                            className="each_plan_text_button"
                          >
                            {" "}
                            Know More
                          </Text>
                        </Stack>
                      </Box>
                      <Box w={"100%"} height={"24px"}></Box>

                      <Stack>
                        <ExtLink
                          as={"a"}
                          // href={"/dashboard/pricing"}
                          onClick={navigateToPricing}
                          _hover={{
                            textDecoration: "none",
                          }}
                          data-fast-goal={`${pageName}_${SECTION_NAME}_pay_but`}
                        >
                          <Box
                            size={"sm"}
                            width={"full"}
                            height={"12"}
                            margin={"0 auto"}
                            border={"1px solid"}
                            borderColor={"brand.red"}
                            borderRadius={"full"}
                            className="each_plan_button"
                            fontFamily={"heading"}
                            fontWeight={"500"}
                            fontSize={{ base: "sm", md: "md" }}
                            lineHeight={"38px"}
                            paddingTop={"4px"}
                            textAlign={"center"}
                            _hover={{
                              textDecoration: "none",
                            }}
                          >
                            Get Started
                          </Box>
                        </ExtLink>
                      </Stack>
                    </MotionStack>

                    <MotionStack
                      border={"2px solid"}
                      borderColor="brand.lightGray"
                      py={8}
                      px={6}
                      width="300px"
                      mt={6}
                      className="each_plan"
                      initial={{ opacity: 0, y: 10 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.3, delay: 0.3 }}
                    >
                      <Box maxW={"48px"}>
                        <FaPlane size={"24"} color="#E33535" />
                      </Box>
                      <Text
                        as={"div"}
                        textAlign={"start"}
                        fontSize={"4xl"}
                        color={"brand.white"}
                        fontFamily={"heading"}
                        fontWeight={"700"}
                      >
                        Grow
                      </Text>

                      <Flex justifyContent={"start"}>
                        <Box>
                          <Text
                            as={"div"}
                            fontSize={"2xl"}
                            fontWeight={"500"}
                            color={"brand.white"}
                            fontFamily={"heading"}
                            px={1}
                          >
                            $349
                            <Text
                              as={"span"}
                              fontSize={"lg"}
                              fontWeight={"400"}
                              color={"brand.lightGray"}
                              opacity={0.5}
                            >
                              /month
                            </Text>
                          </Text>
                        </Box>
                      </Flex>

                      <Stack mt={6}>
                        <Stack spacing={3}>
                          <Stack
                            direction={"row"}
                            pt={1}
                            className="plan_bullet_points"
                          >
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.yellow"
                              fontWeight={"500"}
                            >
                              {" "}
                              Unlimited Credits
                            </Text>
                          </Stack>

                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              150 RPC req/sec
                            </Text>
                          </Stack>

                          <Stack
                            direction={"row"}
                            pt={1}
                            className="plan_bullet_points"
                          >
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.yellow"
                              fontWeight={"500"}
                            >
                              {" "}
                              gRPC Access
                            </Text>
                          </Stack>
                          <Stack
                            direction={"row"}
                            pt={1}
                            className="plan_bullet_points"
                          >
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.yellow"
                              fontWeight={"500"}
                            >
                              {" "}
                              RabbitStream Access
                            </Text>
                          </Stack>
                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              30 API req/sec
                            </Text>
                          </Stack>
                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              DeFi & GraphQL APIs
                            </Text>
                          </Stack>
                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              Callbacks
                            </Text>
                          </Stack>
                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              Staked Connections
                            </Text>
                          </Stack>
                        </Stack>
                      </Stack>

                      <Box textAlign={"start"} pt={"16px"} height={"52px"}>
                        <Stack
                          direction={"row"}
                          onClick={() => highlightSection("grow")}
                          cursor={"pointer"}
                        >
                          <Box>
                            <Box pt={"2px"}>
                              <FiChevronsDown
                                color="#E33535"
                                className="know_more_arrow"
                                size={"20px"}
                              />
                            </Box>
                          </Box>
                          <Text
                            as={"div"}
                            fontFamily={"Jost"}
                            fontSize={{ base: "14px", md: "md" }}
                            color="brand.midGrey"
                            fontWeight={"500"}
                            className="each_plan_text_button"
                          >
                            {" "}
                            Know More
                          </Text>
                        </Stack>
                      </Box>

                      <Box w={"100%"} height={"24px"}></Box>

                      <Stack>
                        <ExtLink
                          as={"a"}
                          // href={"/dashboard/pricing"}
                          onClick={navigateToPricing}
                          _hover={{
                            textDecoration: "none",
                          }}
                          data-fast-goal={`${pageName}_${SECTION_NAME}_pay_but`}
                        >
                          <Box
                            size={"sm"}
                            width={"full"}
                            height={"12"}
                            margin={"0 auto"}
                            border={"1px solid"}
                            borderColor={"brand.red"}
                            borderRadius={"full"}
                            className="each_plan_button"
                            fontFamily={"heading"}
                            fontWeight={"500"}
                            fontSize={{ base: "sm", md: "md" }}
                            lineHeight={"38px"}
                            paddingTop={"4px"}
                            textAlign={"center"}
                            _hover={{
                              textDecoration: "none",
                            }}
                          >
                            Get Started
                          </Box>
                        </ExtLink>
                      </Stack>
                    </MotionStack>

                    <MotionStack
                      border={"2px solid"}
                      borderColor="brand.lightGray"
                      py={8}
                      px={6}
                      width="300px"
                      mt={6}
                      className="each_plan"
                      initial={{ opacity: 0, y: 10 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.3, delay: 0.3 }}
                    >
                      <Box maxW={"48px"}>
                        <IoRocketSharp
                          size={"24"}
                          color="#E33535"
                        />
                      </Box>
                      <Text
                        as={"div"}
                        textAlign={"start"}
                        fontSize={"4xl"}
                        color={"brand.white"}
                        fontFamily={"heading"}
                        fontWeight={"700"}
                      >
                        Accelerate
                      </Text>

                      <Flex justifyContent={"start"}>
                        <Box>
                          <Text
                            as={"div"}
                            fontSize={"2xl"}
                            fontWeight={"500"}
                            color={"brand.white"}
                            fontFamily={"heading"}
                            px={1}
                          >
                            $649
                            <Text
                              as={"span"}
                              fontSize={"lg"}
                              fontWeight={"400"}
                              color={"brand.lightGray"}
                              opacity={0.5}
                            >
                              /month
                            </Text>
                          </Text>
                        </Box>
                      </Flex>

                      <Stack mt={6}>
                        <Stack spacing={3}>
                          <Stack
                            direction={"row"}
                            pt={1}
                            className="plan_bullet_points"
                          >
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.yellow"
                              fontWeight={"500"}
                            >
                              {" "}
                              Unlimited Credits
                            </Text>
                          </Stack>

                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              400 RPC req/sec
                            </Text>
                          </Stack>

                          <Stack
                            direction={"row"}
                            pt={1}
                            className="plan_bullet_points"
                          >
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.yellow"
                              fontWeight={"500"}
                            >
                              {" "}
                              gRPC Access
                            </Text>
                          </Stack>
                          <Stack
                            direction={"row"}
                            pt={1}
                            className="plan_bullet_points"
                          >
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.yellow"
                              fontWeight={"500"}
                            >
                              {" "}
                              RabbitStream Access
                            </Text>
                          </Stack>
                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              100 API req/sec
                            </Text>
                          </Stack>
                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              DeFi & GraphQL APIs
                            </Text>
                          </Stack>
                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              Callbacks
                            </Text>
                          </Stack>
                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              Staked Connections
                            </Text>
                          </Stack>
                        </Stack>
                      </Stack>

                      <Box textAlign={"start"} height={"52px"} pt={"16px"}>
                        <Stack
                          direction={"row"}
                          onClick={() => highlightSection("accelerate")}
                          cursor={"pointer"}
                        >
                          <Box>
                            <Box pt={"2px"}>
                              <FiChevronsDown
                                color="#E33535"
                                className="know_more_arrow"
                                size={"20px"}
                              />
                            </Box>
                          </Box>
                          <Text
                            as={"div"}
                            fontFamily={"Jost"}
                            fontSize={{ base: "14px", md: "md" }}
                            color="brand.midGrey"
                            fontWeight={"500"}
                            className="each_plan_text_button"
                            
                          >
                            {" "}
                            Know More
                          </Text>
                        </Stack>
                      </Box>

                      <Box w={"100%"} height={"22px"}></Box>

                      <Stack>
                        <ExtLink
                          as={"a"}
                          // href={"/dashboard/pricing"}
                          onClick={navigateToPricing}
                          _hover={{
                            textDecoration: "none",
                          }}
                          data-fast-goal={`${pageName}_${SECTION_NAME}_pay_but`}
                        >
                          <Box
                            size={"sm"}
                            width={"full"}
                            height={"12"}
                            margin={"0 auto"}
                            border={"1px solid"}
                            borderColor={"brand.red"}
                            borderRadius={"full"}
                            className="each_plan_button"
                            fontFamily={"heading"}
                            fontWeight={"500"}
                            fontSize={{ base: "sm", md: "md" }}
                            lineHeight={"38px"}
                            paddingTop={"4px"}
                            textAlign={"center"}
                            _hover={{
                              textDecoration: "none",
                            }}
                          >
                            Get Started
                          </Box>
                        </ExtLink>
                      </Stack>
                    </MotionStack>
                  </Flex>
                </Stack>
              </Box>
              <Box>
                {/* <Stack>
                  <ExtLink
                    as={"a"}
                    href={""}
                    _hover={{
                      textDecoration: "none",
                    }}
                  >
                    <Box
                      size={"xs"}
                      width={"full"}
                      maxW={"200px"}
                      height={"12"}
                      margin={"0 auto"}
                      border={"1px solid"}
                      borderColor={"brand.red"}
                      borderRadius={"full"}
                      color={"brand.white"}
                      fontFamily={"heading"}
                      fontWeight={"500"}
                      fontSize={{ base: "xs", md: "sm" }}
                      lineHeight={"38px"}
                      paddingTop={"4px"}
                      textAlign={"center"}
                      transition={"all .1s ease-in-out"}
                      _hover={{
                        textDecoration: "none",
                        bg: "brand.red",
                        color: "brand.white",
                      }}
                    >
                      Plan Details
                    </Box>
                  </ExtLink>
                </Stack> */}
                {/* <Box textAlign={"center"} pt={"4px"} height={"38px"}>
                  <Box as={"a"} href="#solana_rpc_grpc_plan_details">
                    <Stack
                      direction={"row"}
                      justifyContent={"center"}
                      cursor={"pointer"}
                    >
                      <Box>
                        <Box pt={"2px"}>
                          <FiChevronsDown
                            color="#E33535"
                            
                            size={"20px"}
                          />
                        </Box>
                      </Box>
                      <Text
                        as={"div"}
                        fontFamily={"Jost"}
                        fontSize={{ base: "14px", md: "md" }}
                        color="brand.midGrey"
                        fontWeight={"500"}
                      >
                        {" "}
                        View Plan Details & Limits
                      </Text>
                    </Stack>
                  </Box>
                </Box> */}
              </Box>
            </TabPanel>

            {/* Dedicated gRPC Nodes Panel */}
            <TabPanel p={0}>
              <Box
                bg={"transparent"}
                borderRadius="xl"
                border="1px solid"
                borderColor={"transparent"}
                overflow="hidden"
                boxShadow="lg"
              >
                <Stack
                  as="div"
                  spacing={{ base: 5 }}
                  pt={{ base: 6, md: 3 }}
                  pb={{ base: 6, md: 8 }}
                >
                  <Flex
                    justifyContent={{
                      base: "space-around",
                      xl: "space-between",
                    }}
                    flexWrap={"wrap"}
                  >
                    <MotionStack
                      border={"2px solid"}
                      borderColor="brand.lightGray"
                      py={8}
                      px={6}
                      width="300px"
                      mt={6}
                      className="each_plan"
                      initial={{ opacity: 0, y: 10 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.3, delay: 0.3 }}
                    >
                      <Box maxW={"48px"} transform={"rotate(20deg)"}>
                        <FaPaperPlane size={"24"} color="#E33535" />
                      </Box>
                      <Text
                        as={"div"}
                        textAlign={"start"}
                        fontSize={"4xl"}
                        color={"brand.white"}
                        fontFamily={"heading"}
                        fontWeight={"700"}
                      >
                        Free
                      </Text>

                      <Flex justifyContent={"start"}>
                        <Box>
                          <Text
                            as={"div"}
                            fontSize={"2xl"}
                            fontWeight={"500"}
                            color={"brand.white"}
                            fontFamily={"heading"}
                            px={1}
                          >
                            $0
                            <Text
                              as={"span"}
                              fontSize={"lg"}
                              fontWeight={"400"}
                              color={"brand.lightGray"}
                              opacity={0.5}
                            >
                              /month
                            </Text>
                          </Text>
                        </Box>
                      </Flex>

                      <Stack mt={6}>
                        <Stack spacing={3}>
                          <Stack
                            direction={"row"}
                            pt={1}
                            className="plan_bullet_points"
                          >
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.yellow"
                              fontWeight={"500"}
                            >
                              {" "}
                              Unlimited Credits
                            </Text>
                          </Stack>

                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              20 RPC req/sec
                            </Text>
                          </Stack>

                          <Stack
                            direction={"row"}
                            pt={1}
                            className="plan_bullet_points"
                            mt={-1}
                          >
                            <Box>
                              <Box pt={"2px"}>
                                <ImCross
                                  color="#808080"
                                  size={15}
                                  opacity={0.4}
                                />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color={"brand.midGrey"}
                              fontWeight={"500"}
                              opacity={0.4}
                            >
                              {" "}
                              No gRPC Access
                            </Text>
                          </Stack>
                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              1 API req/sec
                            </Text>
                          </Stack>
                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <ImCross
                                  color="#808080"
                                  size={15}
                                  opacity={0.4}
                                />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                              opacity={0.4}
                            >
                              {" "}
                              No Auto-Scaling
                            </Text>
                          </Stack>
                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              DeFi & GraphQL APIs
                            </Text>
                          </Stack>
                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <ImCross
                                  color="#808080"
                                  size={15}
                                  opacity={0.4}
                                />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                              opacity={0.4}
                            >
                              {" "}
                              Callbacks
                            </Text>
                          </Stack>
                          <Stack
                            direction={"row"}
                            pt={1}
                            className="plan_bullet_points"
                            mt={-1}
                          >
                            <Box>
                              <Box pt={"2px"}>
                                <ImCross
                                  color="#808080"
                                  size={15}
                                  opacity={0.4}
                                />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color={"brand.midGrey"}
                              fontWeight={"500"}
                              opacity={0.4}
                            >
                              {" "}
                              Staked Connections
                            </Text>
                          </Stack>
                        </Stack>
                      </Stack>

                      <Box
                        textAlign={"center"}
                        pt={"24px"}
                        height={"56px"}
                      ></Box>

                      <Stack
                        as="div"
                        h={{ base: "0px", md: "20px" }}
                        w={{ base: "0px", md: "20px" }}
                      ></Stack>

                      <Stack>
                        <ExtLink
                          as={"a"}
                          // href={"/dashboard/pricing"}
                          onClick={navigateToPricing}
                          _hover={{
                            textDecoration: "none",
                          }}
                        >
                          <Box
                            size={"sm"}
                            width={"full"}
                            height={"12"}
                            margin={"0 auto"}
                            border={"1px solid"}
                            borderColor={"brand.red"}
                            borderRadius={"full"}
                            className="each_plan_button"
                            fontFamily={"heading"}
                            fontWeight={"500"}
                            fontSize={{ base: "sm", md: "md" }}
                            lineHeight={"38px"}
                            paddingTop={"4px"}
                            textAlign={"center"}
                            _hover={{
                              textDecoration: "none",
                            }}
                          >
                            Get Started
                          </Box>
                        </ExtLink>
                      </Stack>
                    </MotionStack>

                    <MotionStack
                      border={"2px solid"}
                      borderColor="brand.lightGray"
                      py={8}
                      px={6}
                      width="300px"
                      mt={6}
                      className="each_plan"
                      initial={{ opacity: 0, y: 10 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.3, delay: 0.3 }}
                    >
                      <Box maxW={"48px"}>
                        <FaHammer size={"24"} color="#E33535" />
                      </Box>
                      <Text
                        as={"div"}
                        textAlign={"start"}
                        fontSize={"4xl"}
                        color={"brand.white"}
                        fontFamily={"heading"}
                        fontWeight={"700"}
                      >
                        Hack
                      </Text>

                      <Flex justifyContent={"start"}>
                        <Box>
                          <Text
                            as={"div"}
                            fontSize={"2xl"}
                            fontWeight={"500"}
                            color={"brand.white"}
                            fontFamily={"heading"}
                            px={1}
                          >
                            $49
                            <Text
                              as={"span"}
                              fontSize={"lg"}
                              fontWeight={"400"}
                              color={"brand.lightGray"}
                              opacity={0.5}
                            >
                              /month
                            </Text>
                          </Text>
                        </Box>
                      </Flex>

                      <Stack mt={6}>
                        <Stack spacing={3}>
                          <Stack
                            direction={"row"}
                            pt={1}
                            className="plan_bullet_points"
                          >
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.yellow"
                              fontWeight={"500"}
                            >
                              {" "}
                              10M Credits every month
                            </Text>
                          </Stack>

                          <Stack
                            direction={"row"}
                            pt={1}
                            className="plan_bullet_points"
                          >
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              50 RPC req/sec
                            </Text>
                          </Stack>

                          <Stack
                            direction={"row"}
                            pt={1}
                            className="plan_bullet_points"
                            mt={-1}
                          >
                            <Box>
                              <Box pt={"2px"}>
                                <ImCross
                                  color="#808080"
                                  size={15}
                                  opacity={0.4}
                                />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color={"brand.midGrey"}
                              fontWeight={"500"}
                              opacity={0.4}
                            >
                              {" "}
                              No gRPC Access
                            </Text>
                          </Stack>

                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              10 API/GraphQL req/sec
                            </Text>
                          </Stack>

                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <ImCross
                                  color="#808080"
                                  size={15}
                                  opacity={0.4}
                                />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                              opacity={0.4}
                            >
                              {" "}
                              No Auto-Scaling
                            </Text>
                          </Stack>
                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              DeFi & GraphQL APIs
                            </Text>
                          </Stack>
                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              Callbacks
                            </Text>
                          </Stack>
                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              Staked Connections
                            </Text>
                          </Stack>
                        </Stack>
                      </Stack>

                      <Box
                        textAlign={"center"}
                        pt={"24px"}
                        height={"52px"}
                      ></Box>

                      <Stack
                        as="div"
                        h={{ base: "0px", md: "20px" }}
                        w={{ base: "0px", md: "20px" }}
                      ></Stack>

                      <Stack>
                        <ExtLink
                          as={"a"}
                          // href={"/dashboard/pricing"}
                          onClick={navigateToPricing}
                          _hover={{
                            textDecoration: "none",
                          }}
                          data-fast-goal={`${pageName}_${SECTION_NAME}_pay_but`}
                        >
                          <Box
                            size={"sm"}
                            width={"full"}
                            height={"12"}
                            margin={"0 auto"}
                            border={"1px solid"}
                            borderColor={"brand.red"}
                            borderRadius={"full"}
                            className="each_plan_button"
                            fontFamily={"heading"}
                            fontWeight={"500"}
                            fontSize={{ base: "sm", md: "md" }}
                            lineHeight={"38px"}
                            paddingTop={"4px"}
                            textAlign={"center"}
                            _hover={{
                              textDecoration: "none",
                            }}
                          >
                            Get Started
                          </Box>
                        </ExtLink>
                      </Stack>
                    </MotionStack>

                    <MotionStack
                      border={"2px solid"}
                      borderColor="brand.lightGray"
                      py={8}
                      px={6}
                      width="300px"
                      mt={6}
                      className="each_plan"
                      initial={{ opacity: 0, y: 10 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.3, delay: 0.3 }}
                    >
                      <Box maxW={"48px"}>
                        <PiPottedPlantFill size={"24"} color="#E33535" />
                      </Box>
                      <Text
                        as={"div"}
                        textAlign={"start"}
                        fontSize={"4xl"}
                        color={"brand.white"}
                        fontFamily={"heading"}
                        fontWeight={"700"}
                      >
                        Launch
                      </Text>

                      <Flex justifyContent={"start"}>
                        <Box>
                          <Text
                            as={"div"}
                            fontSize={"2xl"}
                            fontWeight={"500"}
                            color={"brand.white"}
                            fontFamily={"heading"}
                            px={1}
                          >
                            $199
                            <Text
                              as={"span"}
                              fontSize={"lg"}
                              fontWeight={"400"}
                              color={"brand.lightGray"}
                              opacity={0.5}
                            >
                              /month
                            </Text>
                          </Text>
                        </Box>
                      </Flex>

                      <Stack mt={6}>
                        <Stack spacing={3}>
                          <Stack
                            direction={"row"}
                            pt={1}
                            className="plan_bullet_points"
                          >
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.yellow"
                              fontWeight={"500"}
                            >
                              {" "}
                              100M Credits
                            </Text>
                          </Stack>

                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              150 RPC req/sec
                            </Text>
                          </Stack>

                          <Stack
                            direction={"row"}
                            pt={1}
                            className="plan_bullet_points"
                            mt={-1}
                          >
                            <Box>
                              <Box pt={"2px"}>
                                <ImCross
                                  color="#808080"
                                  size={15}
                                  opacity={0.4}
                                />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color={"brand.midGrey"}
                              fontWeight={"500"}
                              opacity={0.4}
                            >
                              {" "}
                              No gRPC Access
                            </Text>
                          </Stack>

                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              30 API/GraphQL req/sec
                            </Text>
                          </Stack>

                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              $3.3 for each additional 1M credits
                            </Text>
                          </Stack>
                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              DeFi & GraphQL APIs
                            </Text>
                          </Stack>
                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              Callbacks
                            </Text>
                          </Stack>
                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              Staked Connections
                            </Text>
                          </Stack>
                        </Stack>
                      </Stack>

                      <Box
                        textAlign={"center"}
                        pt={"24px"}
                        height={"32px"}
                      ></Box>

                      <Stack
                        as="div"
                        h={{ base: "0px", md: "20px" }}
                        w={{ base: "0px", md: "20px" }}
                      ></Stack>

                      <Stack>
                        <ExtLink
                          as={"a"}
                          // href={"/dashboard/pricing"}
                          onClick={navigateToPricing}
                          _hover={{
                            textDecoration: "none",
                          }}
                          data-fast-goal={`${pageName}_${SECTION_NAME}_pay_but`}
                        >
                          <Box
                            size={"sm"}
                            width={"full"}
                            height={"12"}
                            margin={"0 auto"}
                            border={"1px solid"}
                            borderColor={"brand.red"}
                            borderRadius={"full"}
                            className="each_plan_button"
                            fontFamily={"heading"}
                            fontWeight={"500"}
                            fontSize={{ base: "sm", md: "md" }}
                            lineHeight={"38px"}
                            paddingTop={"4px"}
                            textAlign={"center"}
                            _hover={{
                              textDecoration: "none",
                            }}
                          >
                            Get Started
                          </Box>
                        </ExtLink>
                      </Stack>
                    </MotionStack>

                    <MotionStack
                      border={"2px solid"}
                      borderColor="brand.lightGray"
                      py={8}
                      px={6}
                      width="300px"
                      mt={6}
                      className="each_plan"
                      initial={{ opacity: 0, y: 10 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.3, delay: 0.3 }}
                    >
                      <Box maxW={"48px"}>
                        <MdKeyboardDoubleArrowRight size={"24"} color="#E33535" />
                      </Box>
                      <Text
                        as={"div"}
                        textAlign={"start"}
                        fontSize={"4xl"}
                        color={"brand.white"}
                        fontFamily={"heading"}
                        fontWeight={"700"}
                      >
                        Scale
                      </Text>

                      <Flex justifyContent={"start"}>
                        <Box>
                          <Text
                            as={"div"}
                            fontSize={"2xl"}
                            fontWeight={"500"}
                            color={"brand.white"}
                            fontFamily={"heading"}
                            px={1}
                          >
                            $499
                            <Text
                              as={"span"}
                              fontSize={"lg"}
                              fontWeight={"400"}
                              color={"brand.lightGray"}
                              opacity={0.5}
                            >
                              /month
                            </Text>
                          </Text>
                        </Box>
                      </Flex>

                      <Stack mt={6}>
                        <Stack spacing={3}>
                          <Stack
                            direction={"row"}
                            pt={1}
                            className="plan_bullet_points"
                          >
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.yellow"
                              fontWeight={"500"}
                            >
                              {" "}
                              500M Credits every month
                            </Text>
                          </Stack>

                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              400 RPC req/sec
                            </Text>
                          </Stack>

                          <Stack
                            direction={"row"}
                            pt={1}
                            className="plan_bullet_points"
                            mt={-1}
                          >
                            <Box>
                              <Box pt={"2px"}>
                                <ImCross
                                  color="#808080"
                                  size={15}
                                  opacity={0.4}
                                />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color={"brand.midGrey"}
                              fontWeight={"500"}
                              opacity={0.4}
                            >
                              {" "}
                              No gRPC Access
                            </Text>
                          </Stack>

                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              150 API/GraphQl req/sec
                            </Text>
                          </Stack>

                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              $1.65 for each additional 1M credits
                            </Text>
                          </Stack>
                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              Defi & GraphQL APIs
                            </Text>
                          </Stack>
                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              Callbacks
                            </Text>
                          </Stack>
                          <Stack direction={"row"}>
                            <Box>
                              <Box pt={"2px"}>
                                <FaCheck color="#808080" />
                              </Box>
                            </Box>
                            <Text
                              as={"div"}
                              fontFamily={"Jost"}
                              fontSize={{ base: "14px", md: "md" }}
                              color="brand.midGrey"
                              fontWeight={"500"}
                            >
                              {" "}
                              Staked Connections
                            </Text>
                          </Stack>
                        </Stack>
                      </Stack>

                      <Box textAlign={"center"} pt={0} height={"32px"}></Box>

                      <Stack
                        as="div"
                        h={{ base: "0px", md: "20px" }}
                        w={{ base: "0px", md: "20px" }}
                      ></Stack>

                      <Stack>
                        <ExtLink
                          as={"a"}
                          // href={"/dashboard/pricing"}
                          onClick={navigateToPricing}
                          _hover={{
                            textDecoration: "none",
                          }}
                          data-fast-goal={`${pageName}_${SECTION_NAME}_pay_but`}
                        >
                          <Box
                            size={"sm"}
                            width={"full"}
                            height={"12"}
                            margin={"0 auto"}
                            border={"1px solid"}
                            borderColor={"brand.red"}
                            borderRadius={"full"}
                            className="each_plan_button"
                            fontFamily={"heading"}
                            fontWeight={"500"}
                            fontSize={{ base: "sm", md: "md" }}
                            lineHeight={"38px"}
                            paddingTop={"4px"}
                            textAlign={"center"}
                            _hover={{
                              textDecoration: "none",
                            }}
                          >
                            Get Started
                          </Box>
                        </ExtLink>
                      </Stack>
                    </MotionStack>
                  </Flex>
                </Stack>
              </Box>
            </TabPanel>
          </TabPanels>
        </Tabs>

    
        {/* <Box>
          <Flex
            as="div"
            pt={{ base: 2, md: 2 }}
            flexWrap={"wrap"}
            justifyContent={{ sm: "space-around", md: "space-between" }}
          >
            <MotionStack
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.3, delay: 0.1 }}
              maxW={{ base: "100%", md: "49%" }}
            >
              <Box
                as="div"
                border={"2px solid"}
                borderColor="brand.lightGray"
                borderRadius={"3xl"}
                py={8}
                px={8}
                bg={"transparent"}
                mt={6}
              >
                <Stack wrap={"wrap"} justifyContent={"space-between"}>
                  <Heading
                    as="h3"
                    color={"brand.white"}
                    fontWeight={"600"}
                    fontSize={"3xl"}
                  >
                    Shared gRPC Network{" "}
                  </Heading>
                </Stack>
                <Stack mt={2}>
                  <Text
                    color={"brand.grey"}
                    fontSize={{ base: "14px", lg: "md" }}
                    fontWeight={500}
                  >
                    No credits, no metering, only unlimited streaming. Select
                    the region closest to you and start instantly at{" "}
                    <Text as={"span"} color={"brand.yellow"}>
                      $199/mo
                    </Text>
                    . Each region is powered by multiple nodes for fault
                    tolerance. Reach out to us on{" "}
                    <Text
                      as={"a"}
                      href={linksConfig.DISCORD_LINK}
                      target="_blank"
                      color={"brand.yellow"}
                      _hover={{ color: "brand.red" }}
                    >
                      discord
                    </Text>{" "}
                    for queries.
                  </Text>
                </Stack>
                <Stack mt={{ base: 0, md: 6 }}>
                  <Button
                    as={"a"}
                    href="/dashboard/grpc"
                    target="_blank"
                    pt={"11px"}
                    pb={"12px"}
                    display={"block"}
                    size={"sm"}
                    // width={"28"}
                    height={"10"}
                    maxW={"200px"}
                    border={"1px solid"}
                    borderColor={"brand.red"}
                    bgColor={"brand.black"}
                    color={"brand.white"}
                    borderRadius={"full"}
                    textColor={"#fff"}
                    fontFamily={"heading"}
                    fontWeight={"600"}
                    _hover={{
                      bgColor: "brand.red",
                      color: "brand.white",
                      textDecoration: "none",
                    }}
                    mt={{ base: 3, md: 1, lg: 1 }}
                    textAlign={"center"}
                  >
                    Start gRPC Streaming
                  </Button>
                  
                </Stack>
              </Box>
            </MotionStack>
            <MotionStack
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.3, delay: 0.2 }}
              maxW={{ base: "100%", md: "49%" }}
              id="jup-swap-v6-api"
            >
              <Box
                as="div"
                border={"2px solid"}
                borderColor="brand.lightGray"
                borderRadius={"3xl"}
                py={8}
                px={8}
                bg={"transparent"}
                mt={6}
              >
                <Stack wrap={"wrap"} justifyContent={"space-between"}>
                  <Heading
                    as="h3"
                    color={"brand.white"}
                    fontWeight={"600"}
                    fontSize={"3xl"}
                  >
                    JUP Swap API 🔥{" "}
                  </Heading>
                </Stack>
                <Stack mt={2}>
                  <Text
                    color={"brand.grey"}
                    fontSize={{ base: "14px", lg: "md" }}
                    fontWeight={500}
                  >
                    Access region specific JUP Swap API. No self-hosting
                    required, start trading instantly at{" "}
                    <Text as={"span"} color={"brand.yellow"}>
                      $299/mo
                    </Text>{" "}
                    and{" "}
                    <Text as={"span"} color={"brand.yellow"}>
                      150 req/sec
                    </Text>
                    . No credit system or upper monthly limit. Reach out to us
                    on dashboard support or{" "}
                    <Text
                      as={"a"}
                      href={linksConfig.DISCORD_LINK}
                      target="_blank"
                      color={"brand.yellow"}
                      _hover={{ color: "brand.red" }}
                    >
                      discord
                    </Text>{" "}
                    to get access.
                  </Text>
                </Stack>
                <Stack mt={{ base: 0, md: 6 }}>
                  <Button
                    as={"a"}
                    href={linksConfig.DISCORD_LINK}
                    target="_blank"
                    pt={"12px"}
                    pb={"10px"}
                    display={"block"}
                    size={"sm"}
                    // width={"28"}
                    height={"10"}
                    maxW={"170px"}
                    border={"1px solid"}
                    borderColor={"brand.red"}
                    bgColor={"brand.black"}
                    color={"brand.white"}
                    borderRadius={"full"}
                    textColor={"#fff"}
                    fontFamily={"heading"}
                    fontWeight={"500"}
                    _hover={{
                      bgColor: "brand.red",
                      color: "brand.white",
                      textDecoration: "none",
                    }}
                    mt={{ base: 3, md: 1, lg: 0 }}
                    textAlign={"center"}
                  >
                    Connect with us
                  </Button>
                </Stack>
              </Box>
            </MotionStack>
          </Flex>
        </Box> */}
        <Box>
          <Flex
            as="div"
            pt={{ base: 2, md: 0 }}
            flexWrap={"wrap"}
            justifyContent={{ sm: "space-around", md: "space-between" }}
          >
            <MotionStack
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.3, delay: 0.3 }}
              maxW={{ base: "100%", md: "49%" }}
            >
              <Box
                as="div"
                border={"2px solid"}
                borderColor="brand.lightGray"
                borderRadius={"3xl"}
                py={8}
                px={8}
                bg={"transparent"}
                mt={2}
              >
                <Stack wrap={"wrap"} justifyContent={"space-between"}>
                  <Heading
                    as="h3"
                    color={"brand.white"}
                    fontWeight={"600"}
                    fontSize={"3xl"}
                  >
                    Enterprise{" "}
                  </Heading>
                </Stack>
                <Stack mt={2}>
                  <Text
                    color={"brand.grey"}
                    fontSize={{ base: "14px", lg: "md" }}
                    fontWeight={500}
                  >
                    For business with larger volume or custom requirements. We provide unique solutions tailored for your specific needs.
                    <br />
                    Reach out to us on{" "}
                    <Text
                      as={"a"}
                      href={linksConfig.DISCORD_LINK}
                      target="_blank"
                      color={"brand.yellow"}
                      _hover={{ color: "brand.red" }}
                      data-fast-goal={`${pageName}_${SECTION_NAME}_discord`}
                    >
                      discord
                    </Text>{" "}
                    for queries.
                  </Text>
                </Stack>
                <Stack mt={{ base: 3, md: 6 }} data-fast-goal={`${pageName}_${SECTION_NAME}_connect`}>
                  <PopupButton
                    url="https://calendly.com/shyft-dev/lets-talk"
                    rootElement={document.getElementsByTagName("body")[0]}
                    text=""
                    className={"calendly_button_common"}
                  />
                  {/* <Button
                                        as={"a"}
                                        href="https://discord.gg/8JyZCjRPmr"
                                        target="_blank"
                                        pt={"11px"}
                                        pb={"12px"}
                                        display={"block"}
                                        size={"sm"}
                                        // width={"28"}
                                        height={"10"}
                                        maxW={"170px"}
                                        border={"1px solid"}
                                        borderColor={'brand.red'}
                                        bgColor={'brand.black'}
                                        color={'brand.white'}
                                        borderRadius={"full"}
                                        textColor={"#fff"}
                                        fontFamily={"heading"}
                                        fontWeight={"600"}
                                        _hover={{
                                            bgColor: 'brand.red',
                                            color: 'brand.white',
                                            textDecoration: 'none',
                                        }}
                                        mt={{base: 5, md: 1, lg: 1}}
                                        textAlign={"center"}
                                    >
                                        Connect with us
                                    </Button> */}
                </Stack>
              </Box>
            </MotionStack>
            <MotionStack
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.3, delay: 0.4 }}
              maxW={{ base: "100%", md: "49%" }}
            >
              <Box
                as="div"
                border={"2px solid"}
                borderColor="brand.lightGray"
                borderRadius={"3xl"}
                py={8}
                px={8}
                bg={"transparent"}
                mt={2}
              >
                <Stack wrap={"wrap"} justifyContent={"space-between"}>
                  <Heading
                    as="h3"
                    color={"brand.white"}
                    fontWeight={"600"}
                    fontSize={"3xl"}
                  >
                    Dedicated Solana RPCs{" "}
                  </Heading>
                </Stack>
                <Stack mt={2}>
                  <Text
                    color={"brand.grey"}
                    fontSize={{ base: "14px", lg: "md" }}
                    fontWeight={500}
                  >
                    Boost your development with our fault-tolerant dedicated
                    nodes. Starting from{" "}
                    <Text as={"span"} color={"brand.yellow"}>
                      $1800/mo
                    </Text>
                    . We also deploy a proxy which tracks your node's health and
                    routes to our backup pool in case of lag or downtimes.
                  </Text>
                </Stack>
                <Stack mt={{ base: 0, md: 6 }}>
                  <Button
                    as={"a"}
                    href={linksConfig.DISCORD_LINK}
                    target="_blank"
                    pt={"12px"}
                    pb={"10px"}
                    display={"block"}
                    size={"sm"}
                    // width={"28"}
                    height={"10"}
                    maxW={"170px"}
                    border={"1px solid"}
                    borderColor={"brand.red"}
                    bgColor={"brand.black"}
                    color={"brand.white"}
                    borderRadius={"full"}
                    textColor={"#fff"}
                    fontFamily={"heading"}
                    fontWeight={"500"}
                    _hover={{
                      bgColor: "brand.red",
                      color: "brand.white",
                      textDecoration: "none",
                    }}
                    mt={{ base: 5, md: 1, lg: 0 }}
                    textAlign={"center"}
                    data-fast-goal={`${pageName}_${SECTION_NAME}_conn_w_us`}
                  >
                    Connect with us
                  </Button>
                </Stack>
              </Box>
            </MotionStack>
          </Flex>
        </Box>

        <Box
          ref={definedRef}
          id="compare-plans"
          paddingTop={"80px"}
          display={{ base: "none", md: "block" }}
        >
          <Box pt={{ base: 2, md: 4 }} pb={{ base: 10, md: 16 }}>
              <CombinedHeading
                topHeading="Side-by-Side Plan Comparison"
                mainHeading="Compare Plans"
                subHeading="Compare RPC & gRPC Pricing – Choose The Plan Best Suited For Your Needs"
                isCenter={true}
              />
          </Box>
          
          <Box>
            <Flex>
              <Box flex={5} pe={"24px"}>
                <Box>
                  <Stack spacing={0}>
                    <Box>
                      <Text
                        as={"div"}
                        fontSize={"lg"}
                        fontWeight={"400"}
                        color={"brand.white"}
                        fontFamily={"heading"}
                        px={1}
                        paddingTop={"74px"}
                        paddingBottom={"8"}
                        borderBottom={"1px solid"}
                        borderBottomColor={"brand.faintGrey"}
                      >
                        Solana RPCs
                      </Text>
                    </Box>
                    {featureList.rpc.map((value, index) => (
                      <Box
                        ps={1}
                        pe={4}
                        pt={4}
                        pb={3}
                        borderBottom={"1px solid"}
                        borderBottomColor={
                          index === featureList.length - 1
                            ? "brand.white"
                            : "brand.faintGrey"
                        }
                      >
                        <Flex>
                          <Text
                            as={"div"}
                            fontSize={"md"}
                            fontWeight={"400"}
                            color={"brand.midGrey"}
                            fontFamily={"body"}
                          >
                            {value}
                          </Text>
                          {index === 2 && (
                            <Tooltip
                              label="Index calls such as getProgramAccounts, getTokenLargetAccounts, getTokenAccountsByOwner"
                              fontSize="xs"
                            >
                              <Box ps={2} marginTop={"-2px"}>
                                <WarningIcon color={"brand.midGrey"} />
                              </Box>
                            </Tooltip>
                          )}
                        </Flex>
                      </Box>
                    ))}
                  </Stack>
                </Box>
              </Box>
              <Box flex={13} overflowX={{ sm: "scroll", md: "hidden" }}>
                <Flex>
                  <Box flex={1} textAlign={"center"}>
                    <Stack spacing={0}>
                      <Box
                        id="free"
                        paddingTop={"2"}
                        paddingBottom={"4"}
                        borderRight={"1px solid"}
                        borderColor={"brand.faintGrey"}
                        borderBottom={"1px solid"}
                        borderBottomColor={"brand.faintGrey"}
                        borderTop={"1px solid"}
                        borderTopColor={"brand.faintGrey"}
                        borderTopLeftRadius={"2xl"}
                        borderLeft={"1px solid"}
                        borderLeftColor={"brand.faintGrey"}
                        bg={currentlySelected === "FREE" ? "brand.red" : ""}
                      >
                        <Text
                          as={"div"}
                          fontSize={"3xl"}
                          fontWeight={"400"}
                          color={"brand.white"}
                          fontFamily={"heading"}
                          px={1}
                        >
                          Free
                        </Text>
                        <Box
                          fontSize={"sm"}
                          color={
                            currentlySelected === "FREE"
                              ? "brand.white"
                              : "brand.midGrey"
                          }
                          mt={"-2px"}
                          fontWeight={
                            currentlySelected === "FREE" ? "500" : "400"
                          }
                        >
                          $0/mo
                        </Box>
                        <ExtLink
                          as={"a"}
                          // href={"/dashboard/pricing"}
                          onClick={navigateToPricing}
                          _hover={{
                            textDecoration: "none",
                          }}
                        >
                          <Button
                            rightIcon={<IoMdArrowDropright />}
                            size={"xs"}
                            borderRadius={"full"}
                            fontWeight={"400"}
                            color={
                              currentlySelected === "FREE"
                                ? "brand.red"
                                : "brand.white"
                            }
                            bg={
                              currentlySelected === "FREE"
                                ? "brand.white"
                                : "transparent"
                            }
                            border={"1px solid"}
                            borderColor={
                              currentlySelected === "FREE"
                                ? "brand.red"
                                : "brand.red"
                            }
                            _hover={{
                              bg:
                                currentlySelected === "FREE"
                                  ? "brand.white"
                                  : "brand.red",
                            }}
                            mt={4}
                            px={"12px"}
                            py={"12px"}
                          >
                            Get Started
                          </Button>
                        </ExtLink>
                      </Box>
                      {Object.values(FREE_DETAILS.rpc).map((value, index) => (
                        <Box flex={1}>
                          <Text
                            as={"div"}
                            fontSize={"md"}
                            fontWeight={"400"}
                            color={
                              currentlySelected === "FREE"
                                ? "brand.white"
                                : "brand.grey"
                            }
                            fontFamily={"body"}
                            ps={1}
                            pe={4}
                            pt={3}
                            pb={4}
                            borderBottom={"1px solid"}
                            borderBottomColor={"brand.faintGrey"}
                            borderLeft={"1px solid"}
                            borderLeftColor={"brand.faintGrey"}
                            borderBottomLeftRadius={
                              index ===
                              Object.values(FREE_DETAILS.rpc).length - 1
                                ? "2xl"
                                : "0px"
                            }
                            bg={currentlySelected === "FREE" ? "#000" : ""}
                          >
                            {typeof value === "boolean" ? (
                              value ? (
                                <Box
                                  display={"flex"}
                                  justifyContent={"center"}
                                  py={"4px"}
                                >
                                  <FaCheck color="#E33535" />
                                </Box>
                              ) : (
                                <Box>--</Box>
                              )
                            ) : (
                              <Box as="span">{value}</Box>
                            )}
                          </Text>
                        </Box>
                      ))}
                    </Stack>
                  </Box>

                  <Box flex={1} textAlign={"center"} id="build">
                    <Stack spacing={0}>
                      <Box
                        id="free"
                        paddingTop={"2"}
                        paddingBottom={"4"}
                        borderRight={"1px solid"}
                        borderColor={"brand.faintGrey"}
                        borderBottom={"1px solid"}
                        borderBottomColor={"brand.faintGrey"}
                        borderTop={"1px solid"}
                        borderTopColor={"brand.faintGrey"}
                        borderLeft={"1px solid"}
                        borderLeftColor={"brand.faintGrey"}
                        bg={currentlySelected === "BUILD" ? "brand.red" : ""}
                      >
                        <Text
                          as={"div"}
                          fontSize={"3xl"}
                          fontWeight={"400"}
                          color={"brand.white"}
                          fontFamily={"heading"}
                          px={1}
                        >
                          Build
                        </Text>
                        <Box
                          fontSize={"sm"}
                          color={
                            currentlySelected === "BUILD"
                              ? "brand.white"
                              : "brand.midGrey"
                          }
                          mt={"-2px"}
                          fontWeight={
                            currentlySelected === "BUILD" ? "500" : "400"
                          }
                        >
                          $199/mo
                        </Box>
                        <ExtLink
                          as={"a"}
                          // href={"/dashboard/pricing"}
                          onClick={navigateToPricing}
                          _hover={{
                            textDecoration: "none",
                          }}
                        >
                          <Button
                            rightIcon={<IoMdArrowDropright />}
                            size={"xs"}
                            borderRadius={"full"}
                            fontWeight={"400"}
                            color={
                              currentlySelected === "BUILD"
                                ? "brand.red"
                                : "brand.white"
                            }
                            bg={
                              currentlySelected === "BUILD"
                                ? "brand.white"
                                : "transparent"
                            }
                            border={"1px solid"}
                            borderColor={
                              currentlySelected === "BUILD"
                                ? "brand.red"
                                : "brand.red"
                            }
                            _hover={{
                              bg:
                                currentlySelected === "BUILD"
                                  ? "brand.white"
                                  : "brand.red",
                            }}
                            mt={4}
                            px={"12px"}
                            py={"12px"}
                          >
                            Get Started
                          </Button>
                        </ExtLink>
                      </Box>
                      {Object.values(BUILD_DETAILS.rpc).map((value, index) => (
                        <Box>
                          <Text
                            as={"div"}
                            fontSize={"md"}
                            fontWeight={"400"}
                            color={
                              currentlySelected === "BUILD"
                                ? "brand.white"
                                : "brand.grey"
                            }
                            fontFamily={"body"}
                            ps={1}
                            pe={4}
                            pt={3}
                            pb={4}
                            borderBottom={"1px solid"}
                            borderBottomColor={"brand.faintGrey"}
                            borderLeft={"1px solid"}
                            borderLeftColor={"brand.faintGrey"}
                            borderTopColor={"brand.faintGrey"}
                            bg={currentlySelected === "BUILD" ? "#000" : ""}
                          >
                            {typeof value === "boolean" ? (
                              value ? (
                                <Box
                                  display={"flex"}
                                  justifyContent={"center"}
                                  py={"4px"}
                                >
                                  <FaCheck color="#E33535" />
                                </Box>
                              ) : (
                                <Box>--</Box>
                              )
                            ) : (
                              <Box as="span">{value}</Box>
                            )}
                          </Text>
                        </Box>
                      ))}
                    </Stack>
                  </Box>

                  <Box flex={1} textAlign={"center"} id="grow">
                    <Stack spacing={0}>
                      <Box
                        id="free"
                        paddingTop={"2"}
                        paddingBottom={"4"}
                        borderRight={"1px solid"}
                        borderColor={"brand.faintGrey"}
                        borderBottom={"1px solid"}
                        borderBottomColor={"brand.faintGrey"}
                        borderTop={"1px solid"}
                        borderTopColor={"brand.faintGrey"}
                        borderLeft={"1px solid"}
                        borderLeftColor={"brand.faintGrey"}
                        bg={currentlySelected === "GROW" ? "brand.red" : ""}
                      >
                        <Text
                          as={"div"}
                          fontSize={"3xl"}
                          fontWeight={"400"}
                          color={"brand.white"}
                          fontFamily={"heading"}
                          px={1}
                        >
                          Grow
                        </Text>
                        <Box
                          fontSize={"sm"}
                          color={
                            currentlySelected === "GROW"
                              ? "brand.white"
                              : "brand.midGrey"
                          }
                          mt={"-2px"}
                          fontWeight={
                            currentlySelected === "GROW" ? "500" : "400"
                          }
                        >
                          $349/mo
                        </Box>
                        <ExtLink
                          as={"a"}
                          // href={"/dashboard/pricing"}
                          onClick={navigateToPricing}
                          _hover={{
                            textDecoration: "none",
                          }}
                        >
                          <Button
                            rightIcon={<IoMdArrowDropright />}
                            size={"xs"}
                            borderRadius={"full"}
                            fontWeight={"400"}
                            color={
                              currentlySelected === "GROW"
                                ? "brand.red"
                                : "brand.white"
                            }
                            bg={
                              currentlySelected === "GROW"
                                ? "brand.white"
                                : "transparent"
                            }
                            border={"1px solid"}
                            borderColor={
                              currentlySelected === "GROW"
                                ? "brand.red"
                                : "brand.red"
                            }
                            _hover={{
                              bg:
                                currentlySelected === "GROW"
                                  ? "brand.white"
                                  : "brand.red",
                            }}
                            mt={4}
                            px={"12px"}
                            py={"12px"}
                          >
                            Get Started
                          </Button>
                        </ExtLink>
                      </Box>
                      {Object.values(GROW_DETAILS.rpc).map((value, index) => (
                        <Box>
                          <Text
                            as={"div"}
                            fontSize={"md"}
                            fontWeight={"400"}
                            color={
                              currentlySelected === "GROW"
                                ? "brand.white"
                                : "brand.grey"
                            }
                            fontFamily={"body"}
                            ps={1}
                            pe={4}
                            pt={3}
                            pb={4}
                            borderBottom={"1px solid"}
                            borderBottomColor={
                              index === featureList.length - 1
                                ? "brand.faintGrey"
                                : "brand.faintGrey"
                            }
                            borderLeft={"1px solid"}
                            borderLeftColor={"brand.faintGrey"}
                            bg={currentlySelected === "GROW" ? "#000" : ""}
                          >
                            {typeof value === "boolean" ? (
                              value ? (
                                <Box
                                  display={"flex"}
                                  justifyContent={"center"}
                                  py={"4px"}
                                >
                                  <FaCheck color="#E33535" />
                                </Box>
                              ) : (
                                <Box>--</Box>
                              )
                            ) : (
                              <Box as="span">{value}</Box>
                            )}
                          </Text>
                        </Box>
                      ))}
                    </Stack>
                  </Box>

                  <Box flex={1} textAlign={"center"} id="accelerate">
                    <Stack spacing={0}>
                      <Box
                        id="free"
                        paddingTop={"2"}
                        paddingBottom={"4"}
                        borderRight={"1px solid"}
                        borderColor={"brand.faintGrey"}
                        borderBottom={"1px solid"}
                        borderBottomColor={"brand.faintGrey"}
                        borderTop={"1px solid"}
                        borderTopColor={"brand.faintGrey"}
                        borderTopRightRadius={"2xl"}
                        borderLeft={"1px solid"}
                        borderLeftColor={"brand.faintGrey"}
                        bg={
                          currentlySelected === "ACCELERATE" ? "brand.red" : ""
                        }
                      >
                        <Text
                          as={"div"}
                          fontSize={"3xl"}
                          fontWeight={"400"}
                          color={"brand.white"}
                          fontFamily={"heading"}
                          px={1}
                        >
                          Accelerate
                        </Text>
                        <Box
                          fontSize={"sm"}
                          color={
                            currentlySelected === "ACCELERATE"
                              ? "brand.white"
                              : "brand.midGrey"
                          }
                          mt={"-2px"}
                          fontWeight={
                            currentlySelected === "ACCELERATE" ? "500" : "400"
                          }
                        >
                          $649/mo
                        </Box>
                        <ExtLink
                          as={"a"}
                          // href={"/dashboard/pricing"}
                          onClick={navigateToPricing}
                          _hover={{
                            textDecoration: "none",
                          }}
                        >
                          <Button
                            rightIcon={<IoMdArrowDropright />}
                            size={"xs"}
                            borderRadius={"full"}
                            fontWeight={"400"}
                            color={
                              currentlySelected === "ACCELERATE"
                                ? "brand.red"
                                : "brand.white"
                            }
                            bg={
                              currentlySelected === "ACCELERATE"
                                ? "brand.white"
                                : "transparent"
                            }
                            border={"1px solid"}
                            borderColor={
                              currentlySelected === "ACCELERATE"
                                ? "brand.red"
                                : "brand.red"
                            }
                            _hover={{
                              bg:
                                currentlySelected === "ACCELERATE"
                                  ? "brand.white"
                                  : "brand.red",
                            }}
                            mt={4}
                            px={"12px"}
                            py={"12px"}
                          >
                            Get Started
                          </Button>
                        </ExtLink>
                      </Box>
                      {Object.values(ACCELERATE_DETAILS.rpc).map(
                        (value, index) => (
                          <Box>
                            <Text
                              as={"div"}
                              fontSize={"md"}
                              fontWeight={"400"}
                              color={
                                currentlySelected === "ACCELERATE"
                                  ? "brand.white"
                                  : "brand.grey"
                              }
                              fontFamily={"body"}
                              ps={1}
                              pe={4}
                              pt={3}
                              pb={4}
                              borderBottom={"1px solid"}
                              borderBottomColor={"brand.faintGrey"}
                              borderLeft={"1px solid"}
                              borderLeftColor={"brand.faintGrey"}
                              borderRight={"1px solid"}
                              borderRightColor={"brand.faintGrey"}
                              borderBottomRightRadius={
                                index ===
                                Object.values(ACCELERATE_DETAILS.rpc).length - 1
                                  ? "2xl"
                                  : "0px"
                              }
                              bg={
                                currentlySelected === "ACCELERATE" ? "#000" : ""
                              }
                            >
                              {typeof value === "boolean" ? (
                                value ? (
                                  <Box
                                    display={"flex"}
                                    justifyContent={"center"}
                                    py={"4px"}
                                  >
                                    <FaCheck color="#E33535" />
                                  </Box>
                                ) : (
                                  <Box>--</Box>
                                )
                              ) : (
                                <Box as="span">{value}</Box>
                              )}
                            </Text>
                          </Box>
                        )
                      )}
                    </Stack>
                  </Box>
                </Flex>
              </Box>
            </Flex>

            <Box
              pt={10}
              pb={2}
              color={"brand.white"}
              fontFamily={"heading"}
              fontSize={"lg"}
            >
              Yellowstone gRPC
            </Box>

            <Flex>
              <Box flex={5} pe={"24px"}>
                <Box>
                  <Stack spacing={0}>
                    {featureList.grpc.map((value, index) => (
                      <Box
                        ps={1}
                        pe={4}
                        pt={4}
                        pb={3}
                        borderBottom={"1px solid"}
                        borderBottomColor={
                          index === featureList.length - 1
                            ? "brand.white"
                            : "brand.faintGrey"
                        }
                      >
                        <Flex>
                          <Text
                            as={"div"}
                            fontSize={"md"}
                            fontWeight={"400"}
                            color={"brand.midGrey"}
                            fontFamily={"body"}
                          >
                            {value}
                          </Text>
                          {index === 0 && (
                            <Tooltip
                              label="There is no limit on the number of IPs you can connect from. You can have 1 IP with 10 connections or 10 IPs with 1 connections each."
                              fontSize="xs"
                            >
                              <Box ps={2} marginTop={"-2px"}>
                                <WarningIcon color={"brand.midGrey"} />
                              </Box>
                            </Tooltip>
                          )}
                          {index === 1 && (
                            <Tooltip
                              label="Number of gRPC clients that can concurrently connect and stream from any number of IPs."
                              fontSize="xs"
                            >
                              <Box ps={2} marginTop={"-2px"}>
                                <WarningIcon color={"brand.midGrey"} />
                              </Box>
                            </Tooltip>
                          )}
                        </Flex>
                      </Box>
                    ))}
                  </Stack>
                </Box>
              </Box>
              <Box flex={13} overflowX={{ sm: "scroll", md: "hidden" }}>
                <Flex>
                  <Box flex={1} textAlign={"center"}>
                    <Stack spacing={0}>
                      {Object.values(FREE_DETAILS.grpc).map((value, index) => (
                        <Box bg={currentlySelected === "FREE" ? "#000" : ""}>
                          <Text
                            as={"div"}
                            fontSize={"md"}
                            fontWeight={"400"}
                            color={
                              currentlySelected === "FREE"
                                ? "brand.white"
                                : "brand.grey"
                            }
                            fontFamily={"body"}
                            ps={1}
                            pe={4}
                            pt={3}
                            pb={4}
                            borderBottom={"1px solid"}
                            borderBottomColor={"brand.faintGrey"}
                            borderLeft={"1px solid"}
                            borderLeftColor={"brand.faintGrey"}
                            borderBottomLeftRadius={
                              index ===
                              Object.values(FREE_DETAILS.grpc).length - 1
                                ? "2xl"
                                : "0px"
                            }
                            borderTopLeftRadius={index === 0 ? "2xl" : "0px"}
                            borderTop={index === 0 ? "1px solid" : "0px solid"}
                            borderTopColor={"brand.faintGrey"}
                          >
                            {typeof value === "boolean" ? (
                              value ? (
                                <Box
                                  display={"flex"}
                                  justifyContent={"center"}
                                  py={"4px"}
                                >
                                  <FaCheck color="#E33535" />
                                </Box>
                              ) : (
                                <Box>--</Box>
                              )
                            ) : (
                              <Box as="span">{value}</Box>
                            )}
                          </Text>
                        </Box>
                      ))}
                    </Stack>
                  </Box>

                  <Box flex={1} textAlign={"center"}>
                    <Stack spacing={0}>
                      {Object.values(BUILD_DETAILS.grpc).map((value, index) => (
                        <Box>
                          <Text
                            as={"div"}
                            fontSize={"md"}
                            fontWeight={"400"}
                            color={
                              currentlySelected === "BUILD"
                                ? "brand.white"
                                : "brand.grey"
                            }
                            fontFamily={"body"}
                            ps={1}
                            pe={4}
                            pt={3}
                            pb={4}
                            borderBottom={"1px solid"}
                            borderBottomColor={"brand.faintGrey"}
                            borderLeft={"1px solid"}
                            borderLeftColor={"brand.faintGrey"}
                            borderTop={index === 0 ? "1px solid" : "0px solid"}
                            borderTopColor={"brand.faintGrey"}
                            bg={currentlySelected === "BUILD" ? "#000" : ""}
                          >
                            {typeof value === "boolean" ? (
                              value ? (
                                <Box
                                  display={"flex"}
                                  justifyContent={"center"}
                                  py={"4px"}
                                >
                                  <FaCheck color="#E33535" />
                                </Box>
                              ) : (
                                <Box>--</Box>
                              )
                            ) : (
                              <Box as="span">{value}</Box>
                            )}
                          </Text>
                        </Box>
                      ))}
                    </Stack>
                  </Box>

                  <Box flex={1} textAlign={"center"}>
                    <Stack spacing={0}>
                      {Object.values(GROW_DETAILS.grpc).map((value, index) => (
                        <Box>
                          <Text
                            as={"div"}
                            fontSize={"md"}
                            fontWeight={"400"}
                            color={
                              currentlySelected === "GROW"
                                ? "brand.white"
                                : "brand.grey"
                            }
                            fontFamily={"body"}
                            ps={1}
                            pe={4}
                            pt={3}
                            pb={4}
                            borderBottom={"1px solid"}
                            borderBottomColor={"brand.faintGrey"}
                            borderLeft={"1px solid"}
                            borderLeftColor={"brand.faintGrey"}
                            borderTop={index === 0 ? "1px solid" : "0px solid"}
                            borderTopColor={"brand.faintGrey"}
                            bg={currentlySelected === "GROW" ? "#000" : ""}
                          >
                            {typeof value === "boolean" ? (
                              value ? (
                                <Box
                                  display={"flex"}
                                  justifyContent={"center"}
                                  py={"4px"}
                                >
                                  <FaCheck color="#E33535" />
                                </Box>
                              ) : (
                                <Box>--</Box>
                              )
                            ) : (
                              <Box as="span">{value}</Box>
                            )}
                          </Text>
                        </Box>
                      ))}
                    </Stack>
                  </Box>

                  <Box flex={1} textAlign={"center"}>
                    <Stack spacing={0}>
                      {Object.values(ACCELERATE_DETAILS.grpc).map(
                        (value, index) => (
                          <Box>
                            <Text
                              as={"div"}
                              fontSize={"md"}
                              fontWeight={"400"}
                              color={
                                currentlySelected === "ACCELERATE"
                                  ? "brand.white"
                                  : "brand.grey"
                              }
                              fontFamily={"body"}
                              ps={1}
                              pe={4}
                              pt={3}
                              pb={4}
                              borderBottom={"1px solid"}
                              borderBottomColor={"brand.faintGrey"}
                              borderLeft={"1px solid"}
                              borderLeftColor={"brand.faintGrey"}
                              borderRight={"1px solid"}
                              borderRightColor={"brand.faintGrey"}
                              borderBottomRightRadius={
                                index ===
                                Object.values(ACCELERATE_DETAILS.grpc).length -
                                  1
                                  ? "2xl"
                                  : "0px"
                              }
                              borderTopRightRadius={index === 0 ? "2xl" : "0px"}
                              borderTop={
                                index === 0 ? "1px solid" : "0px solid"
                              }
                              borderTopColor={"brand.faintGrey"}
                              bg={
                                currentlySelected === "ACCELERATE" ? "#000" : ""
                              }
                            >
                              {typeof value === "boolean" ? (
                                value ? (
                                  <Box
                                    display={"flex"}
                                    justifyContent={"center"}
                                    py={"4px"}
                                  >
                                    <FaCheck color="#E33535" />
                                  </Box>
                                ) : (
                                  <Box>--</Box>
                                )
                              ) : (
                                <Box as="span">{value}</Box>
                              )}
                            </Text>
                          </Box>
                        )
                      )}
                    </Stack>
                  </Box>
                </Flex>
              </Box>
            </Flex>

            <Box
              pt={10}
              pb={2}
              color={"brand.white"}
              fontFamily={"heading"}
              fontSize={"lg"}
            >
              Solana APIs
            </Box>
            <Flex>
              <Box flex={5} pe={"24px"}>
                <Box>
                  <Stack spacing={0}>
                    {featureList.api.map((value, index) => (
                      <Box>
                        <Text
                          as={"div"}
                          fontSize={"md"}
                          fontWeight={"400"}
                          color={"brand.midGrey"}
                          fontFamily={"body"}
                          ps={1}
                          pe={4}
                          pt={4}
                          pb={3}
                          borderBottom={"1px solid"}
                          borderBottomColor={
                            index === featureList.length - 1
                              ? "brand.white"
                              : "brand.faintGrey"
                          }
                        >
                          {value}
                        </Text>
                      </Box>
                    ))}
                  </Stack>
                </Box>
              </Box>
              <Box flex={13} overflowX={{ sm: "scroll", md: "hidden" }}>
                <Flex>
                  <Box flex={1} textAlign={"center"}>
                    <Stack spacing={0}>
                      {Object.values(FREE_DETAILS.api).map((value, index) => (
                        <Box bg={currentlySelected === "FREE" ? "#000" : ""}>
                          <Text
                            as={"div"}
                            fontSize={"md"}
                            fontWeight={"400"}
                            color={
                              currentlySelected === "FREE"
                                ? "brand.white"
                                : "brand.grey"
                            }
                            fontFamily={"body"}
                            ps={1}
                            pe={4}
                            pt={3}
                            pb={4}
                            borderBottom={"1px solid"}
                            borderBottomColor={"brand.faintGrey"}
                            borderLeft={"1px solid"}
                            borderLeftColor={"brand.faintGrey"}
                            borderBottomLeftRadius={
                              index ===
                              Object.values(FREE_DETAILS.api).length - 1
                                ? "2xl"
                                : "0px"
                            }
                            borderTopLeftRadius={index === 0 ? "2xl" : "0px"}
                            borderTop={index === 0 ? "1px solid" : "0px solid"}
                            borderTopColor={"brand.faintGrey"}
                          >
                            {typeof value === "boolean" ? (
                              value ? (
                                <Box
                                  display={"flex"}
                                  justifyContent={"center"}
                                  py={"4px"}
                                >
                                  <FaCheck color="#E33535" />
                                </Box>
                              ) : (
                                <Box>--</Box>
                              )
                            ) : (
                              <Box as="span">{value}</Box>
                            )}
                          </Text>
                        </Box>
                      ))}
                    </Stack>
                  </Box>

                  <Box flex={1} textAlign={"center"}>
                    <Stack spacing={0}>
                      {Object.values(BUILD_DETAILS.api).map((value, index) => (
                        <Box bg={currentlySelected === "BUILD" ? "#000" : ""}>
                          <Text
                            as={"div"}
                            fontSize={"md"}
                            fontWeight={"400"}
                            color={
                              currentlySelected === "BUILD"
                                ? "brand.white"
                                : "brand.grey"
                            }
                            fontFamily={"body"}
                            ps={1}
                            pe={4}
                            pt={3}
                            pb={4}
                            borderBottom={"1px solid"}
                            borderBottomColor={"brand.faintGrey"}
                            borderLeft={"1px solid"}
                            borderLeftColor={"brand.faintGrey"}
                            borderTop={index === 0 ? "1px solid" : "0px solid"}
                            borderTopColor={"brand.faintGrey"}
                          >
                            {typeof value === "boolean" ? (
                              value ? (
                                <Box
                                  display={"flex"}
                                  justifyContent={"center"}
                                  py={"4px"}
                                >
                                  <FaCheck color="#E33535" />
                                </Box>
                              ) : (
                                <Box>--</Box>
                              )
                            ) : (
                              <Box as="span">{value}</Box>
                            )}
                          </Text>
                        </Box>
                      ))}
                    </Stack>
                  </Box>

                  <Box flex={1} textAlign={"center"}>
                    <Stack spacing={0}>
                      {Object.values(GROW_DETAILS.api).map((value, index) => (
                        <Box bg={currentlySelected === "GROW" ? "#000" : ""}>
                          <Text
                            as={"div"}
                            fontSize={"md"}
                            fontWeight={"400"}
                            color={
                              currentlySelected === "GROW"
                                ? "brand.white"
                                : "brand.grey"
                            }
                            fontFamily={"body"}
                            ps={1}
                            pe={4}
                            pt={3}
                            pb={4}
                            borderBottom={"1px solid"}
                            borderBottomColor={
                              index === featureList.length - 1
                                ? "brand.faintGrey"
                                : "brand.faintGrey"
                            }
                            borderLeft={"1px solid"}
                            borderLeftColor={"brand.faintGrey"}
                            borderTop={index === 0 ? "1px solid" : "0px solid"}
                            borderTopColor={"brand.faintGrey"}
                          >
                            {typeof value === "boolean" ? (
                              value ? (
                                <Box
                                  display={"flex"}
                                  justifyContent={"center"}
                                  py={"4px"}
                                >
                                  <FaCheck color="#E33535" />
                                </Box>
                              ) : (
                                <Box>--</Box>
                              )
                            ) : (
                              <Box as="span">{value}</Box>
                            )}
                          </Text>
                        </Box>
                      ))}
                    </Stack>
                  </Box>

                  <Box flex={1} textAlign={"center"}>
                    <Stack spacing={0}>
                      {Object.values(ACCELERATE_DETAILS.api).map(
                        (value, index) => (
                          <Box
                            bg={
                              currentlySelected === "ACCELERATE" ? "#000" : ""
                            }
                          >
                            <Text
                              as={"div"}
                              fontSize={"md"}
                              fontWeight={"400"}
                              color={
                                currentlySelected === "ACCELERATE"
                                  ? "brand.white"
                                  : "brand.grey"
                              }
                              fontFamily={"body"}
                              ps={1}
                              pe={4}
                              pt={3}
                              pb={4}
                              borderBottom={"1px solid"}
                              borderBottomColor={"brand.faintGrey"}
                              borderLeft={"1px solid"}
                              borderLeftColor={"brand.faintGrey"}
                              borderRight={"1px solid"}
                              borderRightColor={"brand.faintGrey"}
                              borderBottomRightRadius={
                                index ===
                                Object.values(ACCELERATE_DETAILS.api).length - 1
                                  ? "2xl"
                                  : "0px"
                              }
                              borderTopRightRadius={index === 0 ? "2xl" : "0px"}
                              borderTop={
                                index === 0 ? "1px solid" : "0px solid"
                              }
                              borderTopColor={"brand.faintGrey"}
                            >
                              {typeof value === "boolean" ? (
                                value ? (
                                  <Box
                                    display={"flex"}
                                    justifyContent={"center"}
                                    py={"4px"}
                                  >
                                    <FaCheck color="#E33535" />
                                  </Box>
                                ) : (
                                  <Box>--</Box>
                                )
                              ) : (
                                <Box as="span">{value}</Box>
                              )}
                            </Text>
                          </Box>
                        )
                      )}
                    </Stack>
                  </Box>
                </Flex>
              </Box>
            </Flex>
          </Box>
        </Box>
        <Box display={{ base: "block", md: "none" }} paddingTop={"80px"}>
          <Flex flexWrap={"wrap"} justifyContent={"center"}>
            <Button
              m={2}
              flex={1}
              bg={"#000"}
              border={"1px solid"}
              borderColor={"brand.red"}
              bgColor={mobileSelect === "FREE" ? "brand.red" : "transparent"}
              color={"brand.white"}
              borderRadius={"full"}
              textColor={"#fff"}
              fontFamily={"heading"}
              fontWeight={"500"}
              _hover={{
                bgColor: "brand.red",
                color: "brand.white",
                textDecoration: "none",
              }}
              onClick={() => setMobileSelect("FREE")}
            >
              FREE
            </Button>
            <Button
              m={2}
              flex={1}
              bg={"#000"}
              border={"1px solid"}
              borderColor={"brand.red"}
              bgColor={mobileSelect === "BUILD" ? "brand.red" : "transparent"}
              color={"brand.white"}
              borderRadius={"full"}
              textColor={"#fff"}
              fontFamily={"heading"}
              fontWeight={"500"}
              _hover={{
                bgColor: "brand.red",
                color: "brand.white",
                textDecoration: "none",
              }}
              onClick={() => setMobileSelect("BUILD")}
            >
              BUILD
            </Button>
          </Flex>
          <Flex flexWrap={"wrap"} justifyContent={"center"}>
            <Button
              m={2}
              flex={1}
              bg={"#000"}
              border={"1px solid"}
              borderColor={"brand.red"}
              bgColor={mobileSelect === "GROW" ? "brand.red" : "transparent"}
              color={"brand.white"}
              borderRadius={"full"}
              textColor={"#fff"}
              fontFamily={"heading"}
              fontWeight={"500"}
              _hover={{
                bgColor: "brand.red",
                color: "brand.white",
                textDecoration: "none",
              }}
              onClick={() => setMobileSelect("GROW")}
            >
              GROW
            </Button>
            <Button
              m={2}
              flex={1}
              bg={"#000"}
              border={"1px solid"}
              borderColor={"brand.red"}
              bgColor={
                mobileSelect === "ACCELERATE" ? "brand.red" : "transparent"
              }
              color={"brand.white"}
              borderRadius={"full"}
              textColor={"#fff"}
              fontFamily={"heading"}
              fontWeight={"500"}
              _hover={{
                bgColor: "brand.red",
                color: "brand.white",
                textDecoration: "none",
              }}
              onClick={() => setMobileSelect("ACCELERATE")}
            >
              ACCELERATE
            </Button>
          </Flex>
          <Box pt={6}>
            <Box color={"brand.lighterWhite"} fontFamily={"heading"} fontWeight={"500"} pb={"10px"} ps={"8px"}>Solana RPCs</Box>
            <Flex>
              <Box flex={1} borderTop={"1px"} borderBottom={"1px"} borderLeft={"1px"} borderStyle={"solid"} borderColor={"brand.faintGrey"} borderTopLeftRadius={"xl"} borderBottomLeftRadius={"xl"}>
                {featureList.rpc.map((value, index) => (
                  <Box
                    key={index}
                    borderBottom={featureList.rpc.length - 1 === index ? "none" : "1px solid"}
                    borderBottomColor={"brand.faintGrey"}
                    textAlign={"start"}
                    color={"brand.lighterWhite"}
                    fontFamily={"body"}
                    fontWeight={"400"}
                    fontSize={"sm"}
                    py={"12px"}
                    ps={"12px"}
                  >
                    {value}
                  </Box>
                ))}
              </Box>
              {mobileSelect === "FREE" && <Box flex={1} borderTop={"1px"} borderBottom={"1px"} borderRight={"1px"} borderStyle={"solid"} borderColor={"brand.faintGrey"} borderTopRightRadius={"xl"} borderBottomRightRadius={"xl"}>
                {Object.values(FREE_DETAILS.rpc).map((value, index) => (
                  <Box
                    key={index}
                    borderBottom={Object.values(FREE_DETAILS.rpc).length - 1 === index ? "none" : "1px solid"}
                    borderBottomColor={"brand.faintGrey"}
                    textAlign={"end"}
                    color={"brand.lighterWhite"}
                    fontFamily={"body"}
                    fontWeight={"400"}
                    fontSize={"sm"}
                    py={"12px"}
                    pe={"12px"}
                  >
                    {typeof value === "boolean" ? (
                      value ? (
                        <Box
                          display={"flex"}
                          justifyContent={"end"}
                          py={"3px"}
                        >
                          <FaCheck color="#E33535" />
                        </Box>
                      ) : (
                        <Box>--</Box>
                      )
                    ) : (
                      <Box as="span">{value}</Box>
                    )}
                  </Box>
                ))}
              </Box>}

              {mobileSelect === "BUILD" && <Box flex={1} borderTop={"1px"} borderBottom={"1px"} borderRight={"1px"} borderStyle={"solid"} borderColor={"brand.faintGrey"} borderTopRightRadius={"xl"} borderBottomRightRadius={"xl"}>
                {Object.values(BUILD_DETAILS.rpc).map((value, index) => (
                  <Box
                    key={index}
                    borderBottom={Object.values(BUILD_DETAILS.rpc).length - 1 === index ? "none" : "1px solid"}
                    borderBottomColor={"brand.faintGrey"}
                    textAlign={"end"}
                    color={"brand.lighterWhite"}
                    fontFamily={"body"}
                    fontWeight={"400"}
                    fontSize={"sm"}
                    py={"12px"}
                    pe={"12px"}
                  >
                    {typeof value === "boolean" ? (
                      value ? (
                        <Box
                          display={"flex"}
                          justifyContent={"end"}
                          py={"3px"}
                        >
                          <FaCheck color="#E33535" />
                        </Box>
                      ) : (
                        <Box>--</Box>
                      )
                    ) : (
                      <Box as="span">{value}</Box>
                    )}
                  </Box>
                ))}
              </Box>}

              {mobileSelect === "GROW" && <Box flex={1} borderTop={"1px"} borderBottom={"1px"} borderRight={"1px"} borderStyle={"solid"} borderColor={"brand.faintGrey"} borderTopRightRadius={"xl"} borderBottomRightRadius={"xl"}>
                {Object.values(GROW_DETAILS.rpc).map((value, index) => (
                  <Box
                    key={index}
                    borderBottom={Object.values(GROW_DETAILS.rpc).length - 1 === index ? "none" : "1px solid"}
                    borderBottomColor={"brand.faintGrey"}
                    textAlign={"end"}
                    color={"brand.lighterWhite"}
                    fontFamily={"body"}
                    fontWeight={"400"}
                    fontSize={"sm"}
                    py={"12px"}
                    pe={"12px"}
                  >
                    {typeof value === "boolean" ? (
                      value ? (
                        <Box
                          display={"flex"}
                          justifyContent={"end"}
                          py={"3px"}
                        >
                          <FaCheck color="#E33535" />
                        </Box>
                      ) : (
                        <Box>--</Box>
                      )
                    ) : (
                      <Box as="span">{value}</Box>
                    )}
                  </Box>
                ))}
              </Box>}

              {mobileSelect === "ACCELERATE" && <Box flex={1} borderTop={"1px"} borderBottom={"1px"} borderRight={"1px"} borderStyle={"solid"} borderColor={"brand.faintGrey"} borderTopRightRadius={"xl"} borderBottomRightRadius={"xl"}>
                {Object.values(ACCELERATE_DETAILS.rpc).map((value, index) => (
                  <Box
                    key={index}
                    borderBottom={Object.values(ACCELERATE_DETAILS.rpc).length - 1 === index ? "none" : "1px solid"}
                    borderBottomColor={"brand.faintGrey"}
                    textAlign={"end"}
                    color={"brand.lighterWhite"}
                    fontFamily={"body"}
                    fontWeight={"400"}
                    fontSize={"sm"}
                    py={"12px"}
                    pe={"12px"}
                  >
                    {typeof value === "boolean" ? (
                      value ? (
                        <Box
                          display={"flex"}
                          justifyContent={"end"}
                          py={"3px"}
                        >
                          <FaCheck color="#E33535" />
                        </Box>
                      ) : (
                        <Box>--</Box>
                      )
                    ) : (
                      <Box as="span">{value}</Box>
                    )}
                  </Box>
                ))}
              </Box>}
              
            </Flex>
          </Box>
          <Box pt={6}>
            <Box color={"brand.lighterWhite"} fontFamily={"heading"} fontWeight={"500"} pb={"10px"} ps={"8px"}>Yellowstone gRPC</Box>
            <Flex>
              <Box flex={1} borderTop={"1px"} borderBottom={"1px"} borderLeft={"1px"} borderStyle={"solid"} borderColor={"brand.faintGrey"} borderTopLeftRadius={"xl"} borderBottomLeftRadius={"xl"}>
                {featureList.grpc.map((value, index) => (
                  <Box
                    key={index}
                    borderBottom={featureList.grpc.length - 1 === index ? "none" : "1px solid"}
                    borderBottomColor={"brand.faintGrey"}
                    textAlign={"start"}
                    color={"brand.lighterWhite"}
                    fontFamily={"body"}
                    fontWeight={"400"}
                    fontSize={"sm"}
                    py={"12px"}
                    ps={"12px"}
                  >
                    {value}
                  </Box>
                ))}
              </Box>
              {mobileSelect === "FREE" && <Box flex={1} borderTop={"1px"} borderBottom={"1px"} borderRight={"1px"} borderStyle={"solid"} borderColor={"brand.faintGrey"} borderTopRightRadius={"xl"} borderBottomRightRadius={"xl"}>
                {Object.values(FREE_DETAILS.grpc).map((value, index) => (
                  <Box
                    key={index}
                    borderBottom={Object.values(FREE_DETAILS.grpc).length - 1 === index ? "none" : "1px solid"}
                    borderBottomColor={"brand.faintGrey"}
                    textAlign={"end"}
                    color={"brand.lighterWhite"}
                    fontFamily={"body"}
                    fontWeight={"400"}
                    fontSize={"sm"}
                    py={"12px"}
                    pe={"12px"}
                  >
                    {typeof value === "boolean" ? (
                      value ? (
                        <Box
                          display={"flex"}
                          justifyContent={"end"}
                          py={"3px"}
                        >
                          <FaCheck color="#E33535" />
                        </Box>
                      ) : (
                        <Box>--</Box>
                      )
                    ) : (
                      <Box as="span">{value}</Box>
                    )}
                  </Box>
                ))}
              </Box>}

              {mobileSelect === "BUILD" && <Box flex={1} borderTop={"1px"} borderBottom={"1px"} borderRight={"1px"} borderStyle={"solid"} borderColor={"brand.faintGrey"} borderTopRightRadius={"xl"} borderBottomRightRadius={"xl"}>
                {Object.values(BUILD_DETAILS.grpc).map((value, index) => (
                  <Box
                    key={index}
                    borderBottom={Object.values(BUILD_DETAILS.grpc).length - 1 === index ? "none" : "1px solid"}
                    borderBottomColor={"brand.faintGrey"}
                    textAlign={"end"}
                    color={"brand.lighterWhite"}
                    fontFamily={"body"}
                    fontWeight={"400"}
                    fontSize={"sm"}
                    py={"12px"}
                    pe={"12px"}
                  >
                    {typeof value === "boolean" ? (
                      value ? (
                        <Box
                          display={"flex"}
                          justifyContent={"end"}
                          py={"3px"}
                        >
                          <FaCheck color="#E33535" />
                        </Box>
                      ) : (
                        <Box>--</Box>
                      )
                    ) : (
                      <Box as="span">{value}</Box>
                    )}
                  </Box>
                ))}
              </Box>}

              {mobileSelect === "GROW" && <Box flex={1} borderTop={"1px"} borderBottom={"1px"} borderRight={"1px"} borderStyle={"solid"} borderColor={"brand.faintGrey"} borderTopRightRadius={"xl"} borderBottomRightRadius={"xl"}>
                {Object.values(GROW_DETAILS.grpc).map((value, index) => (
                  <Box
                    key={index}
                    borderBottom={Object.values(GROW_DETAILS.grpc).length - 1 === index ? "none" : "1px solid"}
                    borderBottomColor={"brand.faintGrey"}
                    textAlign={"end"}
                    color={"brand.lighterWhite"}
                    fontFamily={"body"}
                    fontWeight={"400"}
                    fontSize={"sm"}
                    py={"12px"}
                    pe={"12px"}
                  >
                    {typeof value === "boolean" ? (
                      value ? (
                        <Box
                          display={"flex"}
                          justifyContent={"end"}
                          py={"3px"}
                        >
                          <FaCheck color="#E33535" />
                        </Box>
                      ) : (
                        <Box>--</Box>
                      )
                    ) : (
                      <Box as="span">{value}</Box>
                    )}
                  </Box>
                ))}
              </Box>}

              {mobileSelect === "ACCELERATE" && <Box flex={1} borderTop={"1px"} borderBottom={"1px"} borderRight={"1px"} borderStyle={"solid"} borderColor={"brand.faintGrey"} borderTopRightRadius={"xl"} borderBottomRightRadius={"xl"}>
                {Object.values(ACCELERATE_DETAILS.grpc).map((value, index) => (
                  <Box
                    key={index}
                    borderBottom={Object.values(ACCELERATE_DETAILS.grpc).length - 1 === index ? "none" : "1px solid"}
                    borderBottomColor={"brand.faintGrey"}
                    textAlign={"end"}
                    color={"brand.lighterWhite"}
                    fontFamily={"body"}
                    fontWeight={"400"}
                    fontSize={"sm"}
                    py={"12px"}
                    pe={"12px"}
                  >
                    {typeof value === "boolean" ? (
                      value ? (
                        <Box
                          display={"flex"}
                          justifyContent={"end"}
                          py={"3px"}
                        >
                          <FaCheck color="#E33535" />
                        </Box>
                      ) : (
                        <Box>--</Box>
                      )
                    ) : (
                      <Box as="span">{value}</Box>
                    )}
                  </Box>
                ))}
              </Box>}
              
            </Flex>
          </Box>
          <Box pt={6}>
            <Box color={"brand.lighterWhite"} fontFamily={"heading"} fontWeight={"500"} pb={"10px"} ps={"8px"}>Solana APIs</Box>
            <Flex>
              <Box flex={1} borderTop={"1px"} borderBottom={"1px"} borderLeft={"1px"} borderStyle={"solid"} borderColor={"brand.faintGrey"} borderTopLeftRadius={"xl"} borderBottomLeftRadius={"xl"}>
                {featureList.api.map((value, index) => (
                  <Box
                    key={index}
                    borderBottom={featureList.api.length - 1 === index ? "none" : "1px solid"}
                    borderBottomColor={"brand.faintGrey"}
                    textAlign={"start"}
                    color={"brand.lighterWhite"}
                    fontFamily={"body"}
                    fontWeight={"400"}
                    fontSize={"sm"}
                    py={"12px"}
                    ps={"12px"}
                  >
                    {value}
                  </Box>
                ))}
              </Box>
              {mobileSelect === "FREE" && <Box flex={1} borderTop={"1px"} borderBottom={"1px"} borderRight={"1px"} borderStyle={"solid"} borderColor={"brand.faintGrey"} borderTopRightRadius={"xl"} borderBottomRightRadius={"xl"}>
                {Object.values(FREE_DETAILS.api).map((value, index) => (
                  <Box
                    key={index}
                    borderBottom={Object.values(FREE_DETAILS.api).length - 1 === index ? "none" : "1px solid"}
                    borderBottomColor={"brand.faintGrey"}
                    textAlign={"end"}
                    color={"brand.lighterWhite"}
                    fontFamily={"body"}
                    fontWeight={"400"}
                    fontSize={"sm"}
                    py={"12px"}
                    pe={"12px"}
                  >
                    {typeof value === "boolean" ? (
                      value ? (
                        <Box
                          display={"flex"}
                          justifyContent={"end"}
                          py={"3px"}
                        >
                          <FaCheck color="#E33535" />
                        </Box>
                      ) : (
                        <Box>--</Box>
                      )
                    ) : (
                      <Box as="span">{value}</Box>
                    )}
                  </Box>
                ))}
              </Box>}

              {mobileSelect === "BUILD" && <Box flex={1} borderTop={"1px"} borderBottom={"1px"} borderRight={"1px"} borderStyle={"solid"} borderColor={"brand.faintGrey"} borderTopRightRadius={"xl"} borderBottomRightRadius={"xl"}>
                {Object.values(BUILD_DETAILS.api).map((value, index) => (
                  <Box
                    key={index}
                    borderBottom={Object.values(BUILD_DETAILS.api).length - 1 === index ? "none" : "1px solid"}
                    borderBottomColor={"brand.faintGrey"}
                    textAlign={"end"}
                    color={"brand.lighterWhite"}
                    fontFamily={"body"}
                    fontWeight={"400"}
                    fontSize={"sm"}
                    py={"12px"}
                    pe={"12px"}
                  >
                    {typeof value === "boolean" ? (
                      value ? (
                        <Box
                          display={"flex"}
                          justifyContent={"end"}
                          py={"3px"}
                        >
                          <FaCheck color="#E33535" />
                        </Box>
                      ) : (
                        <Box>--</Box>
                      )
                    ) : (
                      <Box as="span">{value}</Box>
                    )}
                  </Box>
                ))}
              </Box>}

              {mobileSelect === "GROW" && <Box flex={1} borderTop={"1px"} borderBottom={"1px"} borderRight={"1px"} borderStyle={"solid"} borderColor={"brand.faintGrey"} borderTopRightRadius={"xl"} borderBottomRightRadius={"xl"}>
                {Object.values(GROW_DETAILS.api).map((value, index) => (
                  <Box
                    key={index}
                    borderBottom={Object.values(GROW_DETAILS.api).length - 1 === index ? "none" : "1px solid"}
                    borderBottomColor={"brand.faintGrey"}
                    textAlign={"end"}
                    color={"brand.lighterWhite"}
                    fontFamily={"body"}
                    fontWeight={"400"}
                    fontSize={"sm"}
                    py={"12px"}
                    pe={"12px"}
                  >
                    {typeof value === "boolean" ? (
                      value ? (
                        <Box
                          display={"flex"}
                          justifyContent={"end"}
                          py={"3px"}
                        >
                          <FaCheck color="#E33535" />
                        </Box>
                      ) : (
                        <Box>--</Box>
                      )
                    ) : (
                      <Box as="span">{value}</Box>
                    )}
                  </Box>
                ))}
              </Box>}

              {mobileSelect === "ACCELERATE" && <Box flex={1} borderTop={"1px"} borderBottom={"1px"} borderRight={"1px"} borderStyle={"solid"} borderColor={"brand.faintGrey"} borderTopRightRadius={"xl"} borderBottomRightRadius={"xl"}>
                {Object.values(ACCELERATE_DETAILS.api).map((value, index) => (
                  <Box
                    key={index}
                    borderBottom={Object.values(ACCELERATE_DETAILS.api).length - 1 === index ? "none" : "1px solid"}
                    borderBottomColor={"brand.faintGrey"}
                    textAlign={"end"}
                    color={"brand.lighterWhite"}
                    fontFamily={"body"}
                    fontWeight={"400"}
                    fontSize={"sm"}
                    py={"12px"}
                    pe={"12px"}
                  >
                    {typeof value === "boolean" ? (
                      value ? (
                        <Box
                          display={"flex"}
                          justifyContent={"end"}
                          py={"3px"}
                        >
                          <FaCheck color="#E33535" />
                        </Box>
                      ) : (
                        <Box>--</Box>
                      )
                    ) : (
                      <Box as="span">{value}</Box>
                    )}
                  </Box>
                ))}
              </Box>}
              
            </Flex>
          </Box>
        </Box>
      </Container>
    </Stack>
  );
}
